import { createIcon } from '@chakra-ui/icons';

export const HeavyClose = createIcon({
  displayName: 'HeavyClose',
  viewBox: '0 0 16 17',
  path: [
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.7139 2.31152C11.9877 2.03703 12.4218 2.01943 12.7168 2.25977L12.7744 2.31152L14.1885 3.72559C14.4631 3.99951 14.4809 4.43446 14.2402 4.72949L14.1885 4.78613L10.4756 8.49902L14.1885 12.2119C14.4814 12.5041 14.4819 12.979 14.1885 13.2725L12.7744 14.6865C12.5005 14.9612 12.0655 14.979 11.7705 14.7383L11.7139 14.6865L8.00098 10.9736L4.28809 14.6865C4.01428 14.961 3.58018 14.9787 3.28516 14.7383L3.22754 14.6865L1.81348 13.2725L1.76172 13.2148C1.53773 12.9405 1.53717 12.5438 1.76172 12.2686L1.81348 12.2119L5.52637 8.49902L1.81348 4.78613L1.76172 4.72949C1.53751 4.45526 1.53739 4.05855 1.76172 3.7832L1.81348 3.72559L3.22754 2.31152C3.50145 2.03691 3.93641 2.01909 4.23145 2.25977L4.28809 2.31152L8.00098 6.02441L11.7139 2.31152Z"
        fill="currentColor"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>,
  ],
});
